<template>
    <div class="sListDiv">
        <div class=" head">
            <div class="head-left" @click="$router.go(-1)"><van-icon name="arrow-left" /></div>
            <div class="head-title">基金</div>
        </div>
        <van-row>
            <van-col span="12" @click="showL = true">分组浏览</van-col>
        </van-row>
        <p class="count">为您检索到{{ totalelements }}条数据</p>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <van-cell v-for="(item, i) in list" :key="i">
                <h2>{{ i + 1 }}.{{ item.title }}</h2>
                <p class=""><span>项目类型:</span>{{ item.type }}</p>
                <p class=""><span>批准时间:</span>{{ item.ratifyyear }}</p>
                <p class="autro">
                    作者：
                    <a @click="autroFun(item.charge)" v-html="item.charge + '; '" v-if="!$route.query.autro"></a>
                    <span v-html="item.charge + '; '" v-else></span>
                </p>
                <p><span>学科小类:</span>{{ item.subject }}</p>
                <p><span>学科大类:</span>{{ item.topsubject }}</p>
                <p><span>依托单位:</span>{{ item.organ }}</p>
            </van-cell>
        </van-list>
        <van-popup v-model="showL" position="left" get-container="#app" class="fund-van-popup-left">
            <van-cell title="分组浏览" />
            <van-collapse v-model="activeName" accordion @change="facet($event)">
                <van-collapse-item :title="item.title" :name="item.name" v-for="(item, index) in collapse" :key="index">
                    <van-checkbox-group v-model="checkbox[item.name]" v-if="searchagList[item.key]">
                        <van-checkbox v-for="(item1, index1) in searchagList[item.key]" :key="index1" :name="item1.key">
                            {{ item1.key }}<span>({{ item1.value }})</span>
                        </van-checkbox>
                    </van-checkbox-group>
                    <p style="text-align:center;padding: 10px 0;" v-else>
                        暂无数据
                    </p>
                </van-collapse-item>
            </van-collapse>
            <van-button type="info" block @click="filter()">确定</van-button>
        </van-popup>
    </div>
</template>

<script>
import api from "@/request/api/search.js";

export default {
    data() {
        return {
            apiType: true,
            list: {},
            totalelements: 0,
            loading: false, // 列表load
            finished: false, // 列表加载完
            showL: false, // 左侧筛选
            activeName: "", //
            searchagList: {}, // 左侧筛选数据
            checkbox: {}, // 左侧选中的值
            data: {}, // 列表接口参数
            sData: {},
            searchkey: "",
            collapse: [
                { title: "项目类型", key: "typeaggs", name: "type" },
                { title: "依托单位", key: "organaggs", name: "organ" },
                { title: "负责人", key: "chargeaggs", name: "charge" },
                { title: "批准年度", key: "ratifyyearaggs", name: "ratifyyear" },
                { title: "学科小类", key: "subjectaggs", name: "subject" },
                { title: "学科大类", key: "topsubjectaggs", name: "topsubject" }
            ], // 左侧筛选分组数据
            word: "",
            page: 1
        };
    },
    created() {
        this.apiParame();
        this.onLoad();
    },
    mounted() {
        this.$store.dispatch("actionsHead", { type: false, title: "基金", iconType: true });
    },
    methods: {
        onLoad() {
            if (this.apiType) {
                if (this.$route.query.autro == undefined) {
                    this.getSearch();
                }
            } else {
                this.page = this.page + 1;
                this.sData.word = this.page;
                this.sData.searchkey = this.searchkey;
                this.sData.action = "changepage";
                this.getSquery();
            }
        },
        getSearch() {
            api.fundSearch(this.$qs.stringify(this.data)).then((res) => {
                this.list = res.data.list;
                this.totalelements = res.data.totalelements;
                this.searchkey = res.data.searchkey;
                this.loading = false;
                this.searchaggs();
                this.apiType = false;
            });
        },
        getSquery() {
            api.fundSquery(this.$qs.stringify(this.sData)).then((res) => {
                if (this.sData.action == "newfilter") {
                    this.list = res.data.list;
                } else {
                    this.list = this.list.concat(res.data.list);
                }
                this.searchkey = res.data.searchkey;
                this.totalelements = res.data.totalelements;
                this.loading = false;
                this.searchaggs();
                if (this.list.length >= res.data.totalelements) {
                    this.finished = true;
                }
            });
        },
        searchaggs() {
            api.fundSearchaggs(this.$qs.stringify({ searchkey: this.searchkey })).then((res) => {
                this.searchagList = res.data;
            });
        },

        autroFun(text) {
            this.$router.push({ path: "/fundList", query: { searchkey: this.searchkey, autro: text } });
        },

        facet(event) {
            this.word = event;
        },
        filter() {
            this.page = 1;
            this.sData.word = this.word + "|or|" + this.checkbox[this.word].join("###");
            this.sData.searchkey = this.searchkey;
            this.sData.action = "newfilter";
            this.showL = false;
            this.getSquery();
        },
        cancel() {
            this.apiParame();
            this.showL = false;
        },

        apiParame() {
            if (this.$route.query.autro != undefined) {
                this.sData.word = "charge|or|" + this.$route.query.autro;
                this.sData.searchkey = this.$route.query.searchkey;
                this.sData.action = "newfilter";
                this.getSquery();
            } else {
                this.data.active = "fund";
                this.data[this.$route.query.type] = this.$route.query.val;
            }
        }
    }
};
</script>

<style lang="less">
.sListDiv {
    min-height: 100%;
    .head {
        background-color: #3187b6;
        .head-left .van-icon,
        .head-title {
            color: #fff;
            font-size: 1.2rem;
        }
    }
    min-height: 100%;
    .count {
        padding: 0.53333rem 0.85333rem 0;
        color: #9a9a9a;
    }
    .van-row {
        height: 2.5rem;
        padding: 0.7rem 0;
        background: #fff;
        border-bottom: 0.05333rem solid #e3e3e3;

        .van-col--12 {
            color: #09718b;
            padding-left: 0.8333rem;
            text-align: left;
        }
    }
    .van-list {
        height: 100%;
        background-color: #f3f3f3;
        .van-cell {
            background-color: #fff;
            margin-bottom: 0.5rem;
            padding: 1rem 0.5rem;
            font-size: 0.9rem;
            h2 {
                margin-bottom: 0.5rem;
                font-size: 1.1rem;
                font-weight: 100;
                color: #333;
                a {
                    color: #0c60a3;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                }
            }
            p {
                color: #999;
                font-size: 0.9rem;
                line-height: 1.4rem;
                span {
                    margin-right: 0.5rem;
                    color: #000;
                }
            }
            .autro {
                margin-top: 0rem !important;
                color: #000;
                a {
                    color: #0c60a3;
                }
                a {
                    padding-right: 10px;
                }
                span {
                    color: #999;
                }
            }
        }
    }
}
.fund-van-popup-left {
    width: 50%;
    height: 100%;
    > .van-cell {
        font-size: 1rem;
    }
    .van-collapse {
        height: calc(100% - 4.69rem);
        overflow: auto;
        .van-collapse-item__content {
            padding: 0 0.85333rem;
            .van-checkbox {
                margin-bottom: 0.5rem;
            }
        }
    }
    .van-button {
        background: #3187b6;
    }
}
</style>
